module.exports = __webpack_public_path__ + "img/img.c8300e59.png";